import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import styled from "styled-components";

const MobileImage = () => {
  const {
    allFile: { nodes },
  } = useStaticQuery(graphql`
    query {
      allFile(
        filter: { relativeDirectory: { eq: "mobile" } }
        sort: { fields: name, order: ASC }
      ) {
        nodes {
          name
          sourceInstanceName
          relativeDirectory
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: TRACED_SVG)
          }
        }
      }
    }
  `);

  const images = withArtDirection(getImage(nodes[0]), [
    {
      media: `(max-width: 768px)`,
      image: getImage(nodes[1]),
    },
  ]);
  return <GatsbyImage image={images} alt="a tu alcance" objectFit="contain" />;
};

export default MobileImage;

const Wrapper = styled(GatsbyImage)``;
